export default __webpack_public_path__ + "media/images/ongletwhite-right-c9182948f7bb664898c00df83b4651c1.png";